interface MobileFilterOption {
  value: string;
  label: string;
}

interface MobileFilterSelectProps {
  label: string;
  value: string;
  options: MobileFilterOption[];
  onChange: (value: string) => void;
}

export function MobileFilterSelect({ label, value, options, onChange }: MobileFilterSelectProps) {
  return (
    <label className="mobile-filter-select">
      <span>{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </label>
  );
}
